import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CabinetModel } from './cabinet.model';

import { Store } from '@ngrx/store';

import { State } from '../../reducers/index';
import { HIDE_HEADER, OVERLAY_START } from '../../actions/header.action';
import { Booking } from '../../actions/booking.action';
import { INFO_UPDATE } from '../../actions/info.action';
import { LOGOUT_REQUEST } from '../../actions/logout.action';

@Component({
  selector: 'consentz-cabinet',
  templateUrl: './cabinet.template.html',
  styleUrls: ['./cabinet.styles.scss']
})
export class CabinetComponent implements OnInit, OnDestroy {
  public model: CabinetModel = new CabinetModel(
    JSON.parse(localStorage.getItem('currentBookingOptions')),
    localStorage.getItem('AppId') ? localStorage.getItem('AppId') : window.location.hash.split('/')[1],
    JSON.parse(localStorage.getItem('currentUser')).user
  );
  public booking$: any = null;

  constructor(
    private store: Store<State>,
    private router: Router
  ) {
    this.store.dispatch({ type: HIDE_HEADER });
    this.booking$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        this.model.currentBookingOptions = data;
      }
      this.model.changeDetectorRefTimeout = setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      });
    });
  }

  public cheskStore(): void {
    this.router.navigate([this.model.widgetIdForRouting +
      (localStorage.getItem('data') && JSON.parse(localStorage.getItem('data')) ? '/confirmation' : '/clinic')]);
  }

  public logout(): void {
    this.store.dispatch({ type: OVERLAY_START });
    this.store.dispatch({ type: LOGOUT_REQUEST });
  }
  // clear store 'info' data
  public clearData(): void {
    localStorage.removeItem('data');
    this.store.dispatch({
      type: INFO_UPDATE,
      payload: {
        clinic: null,
        treatment: null,
        price: null,
        practitioner: null,
        date: null,
        dateBusy: null,
        customer: null,
        token: null,
        data: null,
        time: null,
        type: null,
        details: null
      }
    });
    this.router.navigate([this.model.widgetIdForRouting + '/clinic']);
  }

  public ngOnInit(): void {
    this.model.changeDetectorRefTimeout = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
    localStorage.removeItem('data');
    localStorage.removeItem('treatmentPractitioners');
    localStorage.removeItem('goToTreatment');
    localStorage.removeItem('clinicId');
    localStorage.removeItem('practitionerId');
    localStorage.removeItem('Appointment');
    localStorage.removeItem('treatmentId');
    localStorage.removeItem('treatmentTime');
  }
  // unsubscribe from store
  public ngOnDestroy(): void {
    clearTimeout(this.model.changeDetectorRefTimeout);
    this.booking$.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/cabinet/cabinet.component.ts